var imat = imat || {};

imat.siteRedirection = function () {
    var _view;

    var view = function() {
        var popupSelector = $("#redirectionPopup");

        var popupPresent = function() {
            return popupSelector.length > 0;
        }

        var hidePopup = function() {
            if (popupPresent()) {
                popupSelector.css("display", "none");
            }
        }

        var setWantToStayClickHandler = function(clickHandler) {
            if (!clickHandler) {
                throw "clickHandler should be defined";
            }

            if (typeof (clickHandler) !== 'function') {
                throw "clickHandler should be a function";
            }

            var btnSelector = popupSelector.find('.close');
            btnSelector.bind('click', clickHandler);
        };

        return {
            hidePopup: hidePopup,
            popupPresent: popupPresent,
            setWantToStayClickHandler: setWantToStayClickHandler
        };
    };

        var wantToStayClickHandler = function () {
        _view.hidePopup();
        $.ajax({
            type: "POST",
            async: true,
            url: "/SiteRedirection/SetWantToStayOnMainSite"
        });
    };

    var init = function () {
        _view = view();
        if (_view.popupPresent()) {
            _view.setWantToStayClickHandler(wantToStayClickHandler);
        }
    };

    return {
        init: init
    };
}();

$(document).ready(function () {
    imat.siteRedirection.init();
});